
    import * as bootstrap from 'bootstrap';
    // https://getbootstrap.com/docs/5.0/getting-started/javascript/#sanitizer
    const myDefaultWhiteList = bootstrap.Tooltip.Default.allowList
    myDefaultWhiteList.a.push("onclick")
